document.addEventListener("DOMContentLoaded", function () {
  const BundleShared = window.BundleSharedV1;
  if (!BundleShared) {
    console.error("BundleSharedV1 helper is required before this script.");
    return;
  }

  const {
    safeStorage,
    hideUpCartTemporarily,
    restoreUpCartIfNeeded,
    openPopup,
    closePopup,
    buildRechargeBundleLineItem,
    addItemsToCart,
    ONE_TIME_FREE_LAMP_SELECTION,
  } = BundleShared;

  restoreUpCartIfNeeded();

  function getSelectedUpsellVariantId() {
    const upsellBtn = document.getElementById("add-upsell-onetime");
    const upsellEl = document.querySelector(".upsell-prod");

    if (!upsellBtn || !upsellEl) return null;

    if (upsellBtn.disabled && upsellEl.dataset.variantId) {
      return Number(upsellEl.dataset.variantId);
    }

    return null;
  }

  async function buildRechargeBundleFromPopup({
    redirectToCheckout = false,
    onBeforeRedirect = null,
  } = {}) {
    const activeGroup = getActiveBundleGroup();
    const isSubscription = getActivePurchaseType() !== "one-time";

    const bundleResult = await buildRechargeBundleLineItem({
      groupEl: activeGroup,
      isSubscription,
      extraSelections: isSubscription ? [] : [ONE_TIME_FREE_LAMP_SELECTION],
      missingBundleMessage: "Bundle setup is incomplete.",
      rechargeMissingMessage: "Recharge bundle is not available on this page.",
    });

    if (!bundleResult) return false;

    const finalItems = [bundleResult.parentItem];
    const upsellVariantId = !isSubscription
      ? getSelectedUpsellVariantId()
      : null;

    if (upsellVariantId) {
      finalItems.push({
        id: upsellVariantId,
        quantity: 1,
        properties: {},
      });
    }

    try {
      hideUpCartTemporarily();

      const res = await addItemsToCart(finalItems, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!res.ok) {
        restoreUpCartIfNeeded();
        console.error("❌ Cart add failed:", res.status, res.statusText);
        alert("Error adding bundle to cart.");
        return false;
      }

      if (redirectToCheckout) {
        if (typeof onBeforeRedirect === "function") {
          onBeforeRedirect();
        }

        window.location.href = "/checkout";

        // Prevent UI reset while browser is navigating.
        return new Promise(() => {});
      }

      return true;
    } catch (err) {
      restoreUpCartIfNeeded();
      console.error("❌ Cart request failed:", err);
      alert("Something went wrong. Please try again.");
      return false;
    }
  }

  function isFavorite(productId) {
    const favorites = safeStorage.get("bundleFavorites");
    return favorites.some((item) => item.productId === productId);
  }

  function saveFavorite(
    variantId,
    productId,
    title,
    media,
    collectionId,
    collectionTitle,
  ) {
    let favorites = safeStorage.get("bundleFavorites");
    if (!favorites.some((item) => item.productId === productId)) {
      favorites.push({
        variantId,
        productId,
        title,
        media,
        collectionId,
        collectionTitle,
      });
      safeStorage.set("bundleFavorites", favorites);
      updateHeartStates();
      loadFavorites();
    }
  }

  function removeFavorite(productId) {
    let favorites = safeStorage.get("bundleFavorites");
    favorites = favorites.filter((item) => item.productId !== productId);
    safeStorage.set("bundleFavorites", favorites);
    updateHeartStates();
    loadFavorites();
  }

  function updateHeartStates() {
    document.querySelectorAll(".favorite-btn").forEach((btn) => {
      const id = btn.getAttribute("data-product-id");
      if (id && isFavorite(id)) btn.classList.add("favorited");
      else btn.classList.remove("favorited");
    });
  }

  function updateFavoriteButtonState(btn, id) {
    if (!btn) return;

    if (isFavorite(id)) {
      btn.classList.add("favorited");
      btn.innerHTML = `
        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="pink">
          <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
        </svg>
      `;
    } else {
      btn.classList.remove("favorited");
      btn.innerHTML = `
        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
          <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
        </svg>
      `;
    }
  }

  function loadFavorites() {
    const favGrid = document.querySelector(".favorite-grid");
    if (!favGrid) return;

    const favorites = safeStorage.get("bundleFavorites");

    if (favorites.length === 0) {
      favGrid.innerHTML =
        '<p class="bundle-collection__empty">No favorite products yet.</p>';
      return;
    }

    favGrid.innerHTML = "";
    favorites.forEach((item) => {
      favGrid.insertAdjacentHTML(
        "beforeend",
        `
        <div class="bundle-collection__item" 
            data-product-id="${item.productId}" 
            data-variant-id="${item.variantId}">
          <div class="bundle-collection__image"
            data-variant-id="${item.variantId}"
            data-product-id="${item.productId}"
            data-collection-id="${item.collectionId || ""}"
            data-collection-title="${item.collectionTitle || ""}"
            data-product-title="${item.title}"
            data-product-media="${item.media}">
            <img src="${item.media}" alt="${item.title}" class="bundle-collection__img">
          </div>
          <h3 class="bundle-collection__title">${item.title}</h3>
          <button class="remove-favorite" data-remove-id="${item.productId}">Remove</button>
        </div>
      `,
      );
    });
  }

  let selectedSlot = null;

  const BUNDLE_COMPLETE_FOOTER_CLASS = "is-bundle-complete";
  const CHECKOUT_BUTTON_IDLE_LABEL = "Proceed to checkout";

  function getActivePurchaseType() {
    return BundleShared.getCurrentPurchaseType();
  }

  function getActiveBundleGroup() {
    return BundleShared.getActiveBundleGroup();
  }

  function getBundleSlots(group = null) {
    return BundleShared.getBundleSlots(group || getActiveBundleGroup());
  }

  function getSlotNumber(slot) {
    return BundleShared.getSlotNumber(slot);
  }

  function getNextEmptySlot(fromSlot = null) {
    return BundleShared.getNextEmptySlot(fromSlot, getActiveBundleGroup());
  }

  function getFilledSlotCount(group = null) {
    return BundleShared.getFilledSlotCount(group || getActiveBundleGroup());
  }

  function getRequiredSlotCount(group = null) {
    return BundleShared.getRequiredSlotCount(group || getActiveBundleGroup());
  }

  function isBundleComplete(group = null) {
    return BundleShared.isBundleComplete(group || getActiveBundleGroup());
  }

  function getActiveBundleSection() {
    return BundleShared.getBundleSectionByPurchaseType(getActivePurchaseType());
  }

  function normalizeBundleSet(targetSet = "") {
    const setMatch = String(targetSet || "").match(/\d+/);
    return setMatch ? `set-${setMatch[0]}` : String(targetSet || "");
  }

  function getSetNumber(targetSet = "") {
    return normalizeBundleSet(targetSet).match(/\d+/)?.[0] || "";
  }

  function getSetValue(el, base, setNumber) {
    if (!el || !setNumber) return "";

    const camelKey = `${base}Set${setNumber}`;

    return (
      el.dataset?.[camelKey] ||
      el.getAttribute(`data-${base}-set${setNumber}`) ||
      el.getAttribute(`data-${base}-set-${setNumber}`) ||
      ""
    );
  }

  function getSharedBundleSelector() {
    return (
      document.querySelector("[data-shared-bundle-selector]") ||
      document.querySelector(".bundle-selector")
    );
  }

  function getActiveBundleSet(group = null) {
    const activeGroup = group || getActiveBundleGroup();

    if (activeGroup?.dataset.bundleSet) {
      return normalizeBundleSet(activeGroup.dataset.bundleSet);
    }

    const activeOption =
      getSharedBundleSelector()?.querySelector(
        ".bundle-option.active[data-target]",
      ) ||
      getActiveBundleSection()?.querySelector(
        ".bundle-option.active[data-target]",
      );

    return normalizeBundleSet(activeOption?.dataset.target || "");
  }

  function getBundlePricingForActiveContext(group = null) {
    const activeSet = getActiveBundleSet(group);
    const setNumber = getSetNumber(activeSet);
    const purchaseType = getActivePurchaseType();

    if (!setNumber) return null;

    const activeSection = getActiveBundleSection();
    const scopedPriceEls = Array.from(
      activeSection?.querySelectorAll("[data-bundle-price]") || [],
    );
    const matchingPriceEls = Array.from(
      document.querySelectorAll("[data-bundle-price]"),
    ).filter((el) => {
      return (
        !el.dataset.purchaseType || el.dataset.purchaseType === purchaseType
      );
    });

    const priceEls = [...scopedPriceEls, ...matchingPriceEls].filter(
      (el, index, arr) => arr.indexOf(el) === index,
    );
    const priceEl = priceEls.find((el) => getSetValue(el, "price", setNumber));

    if (!priceEl) return null;

    const price = getSetValue(priceEl, "price", setNumber);
    const compare = getSetValue(priceEl, "compare", setNumber);

    if (!price && !compare) return null;

    return {
      price,
      compare,
      set: activeSet,
      purchaseType,
    };
  }

  function updateFooterCompleteState(isComplete) {
    const footer = document.querySelector(".bundle-popup__footer");
    if (!footer) return;

    footer.classList.toggle(BUNDLE_COMPLETE_FOOTER_CLASS, Boolean(isComplete));
  }

  function getProceedButtonIdleLabel(proceedBtn) {
    if (!proceedBtn.dataset.idleLabel) {
      proceedBtn.dataset.idleLabel =
        proceedBtn.getAttribute("data-checkout-label") ||
        proceedBtn.textContent.trim() ||
        CHECKOUT_BUTTON_IDLE_LABEL;
    }

    return proceedBtn.dataset.idleLabel;
  }

  function updateProceedButtonPrice(proceedBtn, activeGroup = null) {
    const label = getProceedButtonIdleLabel(proceedBtn);
    const pricing = getBundlePricingForActiveContext(activeGroup);

    proceedBtn.classList.toggle("has-price", Boolean(pricing?.price));
    proceedBtn.dataset.purchaseType =
      pricing?.purchaseType || getActivePurchaseType();
    proceedBtn.dataset.bundleSet =
      pricing?.set || getActiveBundleSet(activeGroup);

    const labelTarget = proceedBtn.querySelector(
      "[data-bundle-popup-checkout-label], [data-bundle-checkout-label]",
    );
    const priceTarget = proceedBtn.querySelector(
      "[data-bundle-popup-checkout-price], [data-bundle-checkout-price]",
    );
    const compareTarget = proceedBtn.querySelector(
      "[data-bundle-popup-checkout-compare], [data-bundle-checkout-compare]",
    );

    if (labelTarget || priceTarget || compareTarget) {
      if (labelTarget) labelTarget.textContent = label;
      if (priceTarget) priceTarget.textContent = pricing?.price || "";

      if (compareTarget) {
        compareTarget.textContent = pricing?.compare || "";
        compareTarget.hidden = !pricing?.compare;
      }

      return;
    }

    proceedBtn.textContent = "";

    const labelSpan = document.createElement("span");
    labelSpan.className = "bundle-popup__checkout-label";
    labelSpan.textContent = label;
    proceedBtn.appendChild(labelSpan);

    if (!pricing?.price) return;

    const pricingSpan = document.createElement("span");
    pricingSpan.className = "bundle-popup__checkout-pricing";

    const priceSpan = document.createElement("span");
    priceSpan.className = "bundle-popup__checkout-price";
    priceSpan.textContent = pricing.price;
    pricingSpan.appendChild(priceSpan);

    if (pricing.compare) {
      const compareSpan = document.createElement("s");
      compareSpan.className = "bundle-popup__checkout-compare";
      compareSpan.textContent = pricing.compare;
      pricingSpan.appendChild(compareSpan);
    }

    proceedBtn.appendChild(pricingSpan);
  }

  function updateBundlePopupTitle(slot = null) {
    const popupTitle = document.querySelector(
      "#bundle-collection-popup .bundle-popup__title",
    );
    if (!popupTitle) return;

    const activeGroup = getActiveBundleGroup();
    if (!activeGroup) {
      popupTitle.textContent = "Select Colour 1";
      return;
    }

    if (slot && slot.closest(".bundle-group") === activeGroup) {
      popupTitle.textContent = `Select Colour ${getSlotNumber(slot)}`;
      return;
    }

    const nextEmpty = getNextEmptySlot(null);
    if (nextEmpty) {
      popupTitle.textContent = `Select Colour ${getSlotNumber(nextEmpty)}`;
    } else {
      popupTitle.textContent = "Selected Colours";
    }
  }

  function updateProceedButtonState() {
    const proceedBtn = document.getElementById("bundle-popup-proceed");
    if (!proceedBtn) return;

    const activeGroup = getActiveBundleGroup();
    const complete = isBundleComplete(activeGroup);

    proceedBtn.hidden = !complete;
    proceedBtn.disabled = !complete;
    proceedBtn.classList.toggle("is-visible", complete);

    if (complete && !proceedBtn.classList.contains("is-loading")) {
      updateProceedButtonPrice(proceedBtn, activeGroup);
    }
  }

  function setSlotProduct(slot, data) {
    if (!slot) return;

    slot.dataset.id = data.variantId || "";
    slot.dataset.product = data.productId || "";
    slot.dataset.collection = data.collectionId || "";
    slot.dataset.collectionTitle = data.collectionTitle || "";
    slot.dataset.title = data.title || "";
    slot.dataset.image = data.img || "";

    slot.innerHTML = `
      <div class="bundle-content">
        <img src="${data.img}" alt="${data.title}">
        <p>${data.title}</p>
        <button class="remove-btn" aria-label="Remove product">
          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
            <rect width="41" height="42" rx="7.02" fill="white"/>
            <path d="M26.985 26.9831L21.0882 21.0863L15.1914 15.1895M26.985 15.1895L15.1914 26.9831" stroke="black" stroke-width="1.4742" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `;

    renderSelectedFooter();
  }

  function clearSlot(slot) {
    if (!slot) return;

    const slotNumber = getSlotNumber(slot);

    slot.dataset.id = "";
    slot.dataset.product = "";
    slot.dataset.collection = "";
    slot.dataset.collectionTitle = "";
    slot.dataset.title = "";
    slot.dataset.image = "";

    slot.innerHTML = `
      <div class="empty--slot">
        <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="59" height="59" rx="29.5" fill="white"/>
          <path d="M36.5676 29.6197H29.6178M29.6178 29.6197H22.668M29.6178 29.6197V22.6699M29.6178 29.6197V36.5695" stroke="black" stroke-width="1.73745" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <p>Design ${slotNumber}</p>
    `;

    renderSelectedFooter();
    updateBundlePopupTitle(selectedSlot);
  }

  function renderSelectedFooter() {
    const footerList = document.querySelector(".bundle-popup__selected-list");
    if (!footerList) return;

    const activeGroup = getActiveBundleGroup();
    const slots = getBundleSlots(activeGroup);

    if (!activeGroup || !slots.length) {
      footerList.innerHTML = "";
      updateFooterCompleteState(false);
      updateProceedButtonState();
      return;
    }

    const complete = isBundleComplete(activeGroup);
    updateFooterCompleteState(complete);

    footerList.innerHTML = slots
      .map((slot, index) => {
        const isFilled = slot.dataset.product && slot.dataset.id;

        if (isFilled) {
          const swapButton = complete
            ? `
            <button
              type="button"
              class="bundle-popup__selected-swap bundle-popup__selected-remove"
              data-slot-index="${index}"
              aria-label="Swap ${slot.dataset.title || `Design ${index + 1}`}"
            >
              <span>SWAP</span>
              <div class="bundle-popup__selected-swap-icon" aria-hidden="true">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.01664 0.599976C7.01664 0.599976 7.51203 0.670746 9.56229 2.721C11.6125 4.77125 11.6125 8.09537 9.56229 10.1456C8.83588 10.872 7.94956 11.3411 7.01664 11.5527M7.01664 0.599976L10.5166 0.599976M7.01664 0.599976L7.01664 4.09998M4.68331 12.2665C4.68331 12.2665 4.18792 12.1958 2.13766 10.1455C0.0874124 8.09525 0.0874124 4.77114 2.13767 2.72088C2.86408 1.99447 3.75039 1.52543 4.68331 1.31376M4.68331 12.2665L1.18331 12.2666M4.68331 12.2665L4.68331 8.76664" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              </div>
            </button>
          `
            : "";

          return `
          <div class="bundle-popup__selected-item is-filled" data-slot-index="${index}">
            <button
              type="button"
              class="bundle-popup__selected-remove"
              data-slot-index="${index}"
              aria-label="Remove selected product"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
                <rect width="41" height="42" rx="7.02" fill="white"/>
                <path d="M26.985 26.9831L21.0882 21.0863L15.1914 15.1895M26.985 15.1895L15.1914 26.9831" stroke="black" stroke-width="1.4742" stroke-linecap="round"/>
              </svg>
            </button>

            <div class="bundle-popup__selected-thumb">
              <img src="${slot.dataset.image}" width="100%" height="100%" alt="${slot.dataset.title}">
            </div>

            <div class="bundle-popup__selected-name">
              ${slot.dataset.title}
            </div>

            ${swapButton}
          </div>
        `;
        }

        return `
        <div class="bundle-popup__selected-item is-empty" data-slot-index="${index}">
          <div class="bundle-popup__selected-thumb bundle-popup__selected-thumb--empty">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </div>

          <div class="bundle-popup__selected-name">
            Design ${index + 1}
          </div>
        </div>
      `;
      })
      .join("");

    updateBundlePopupTitle(selectedSlot);
    updateProceedButtonState();
  }

  function selectProductIntoSlot(data) {
    const activeGroup = getActiveBundleGroup();
    if (!activeGroup) return;

    let targetSlot =
      (selectedSlot && selectedSlot.closest(".bundle-group") === activeGroup
        ? selectedSlot
        : null) || getNextEmptySlot(null);

    if (!targetSlot) return;

    setSlotProduct(targetSlot, data);

    const nextSlot = getNextEmptySlot(targetSlot);
    selectedSlot = nextSlot || null;

    updateBundlePopupTitle(selectedSlot);
    renderSelectedFooter();
  }

  function getBundleOptionContent(btn, purchaseType = getActivePurchaseType()) {
    return (
      (purchaseType === "one-time"
        ? btn?.dataset.oneContent
        : btn?.dataset.subContent) ||
      btn?.dataset.content ||
      ""
    );
  }

  function updatePurchaseHeadings(content) {
    if (!content) return;

    document.querySelectorAll("[data-purchase-heading]").forEach((heading) => {
      heading.textContent = content;
    });
  }

  function updateSharedSelectorLabels(purchaseType = getActivePurchaseType()) {
    const selector = getSharedBundleSelector();
    if (!selector) return;

    selector.querySelectorAll(".bundle-option").forEach((btn) => {
      const unit =
        purchaseType === "one-time" ? btn.dataset.oneUnit : btn.dataset.subUnit;
      const content = getBundleOptionContent(btn, purchaseType);
      const small =
        btn.querySelector("[data-bundle-option-unit]") ||
        btn.querySelector("small");

      if (unit && small) small.textContent = unit;
      if (content) btn.dataset.content = content;
    });

    const activeOption = selector.querySelector(
      ".bundle-option.active[data-target]",
    );
    updatePurchaseHeadings(getBundleOptionContent(activeOption, purchaseType));
  }

  function syncBundleGroups(targetSet) {
    const activeSet = normalizeBundleSet(targetSet || getActiveBundleSet());
    if (!activeSet) return;

    document
      .querySelectorAll(".one-time-bundle, .subscription-bundle")
      .forEach((section) => {
        section
          .querySelectorAll(".bundle-group[data-bundle-set]")
          .forEach((group) => {
            const isActiveGroup =
              normalizeBundleSet(group.dataset.bundleSet) === activeSet;
            group.classList.toggle("active", isActiveGroup);
            group.classList.toggle("hidden", !isActiveGroup);
          });
      });
  }

  function updateSubscriptionPricingVisibility(
    purchaseType = getActivePurchaseType(),
  ) {
    document.querySelectorAll("[data-subscription-pricing]").forEach((el) => {
      el.classList.toggle("hidden", purchaseType === "one-time");
    });
  }

  const purchaseBtns = document.querySelectorAll(".purchase-type");
  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");
  const oneTimeBtn = document.querySelector("#add-bundle-onetime");
  const subscriptionBtn = document.querySelector("#add-bundle-subscription");
  const upsellWrapper = document.querySelectorAll(".upsell__wrapper");
  const subUpsellWrapper = document.querySelectorAll(".upsell-accessories");
  const giftWrapper = document.querySelectorAll(".free-gift__wrapper");
  const subscriptionPricingHeaders = document.querySelectorAll(
    "[data-subscription-pricing]",
  );
  const purchaseOptionIconPath = document.querySelector(
    ".purchase-option-icon path",
  );

  const defaultSvgPath =
    "M9 7V9H13V11H10V13H13V15H9V17H13C13.5304 17 14.0391 16.7893 14.4142 16.4142C14.7893 16.0391 15 15.5304 15 15V13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.7893 11.2107 15 10.702 15 10.1716V9C15 8.46957 14.7893 7.96086 14.4142 7.58579C14.0391 7.21071 13.5304 7 13 7H9ZM12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2Z";

  const oneTimeSvgPath =
    "M9 7V9H13V11H11C10.4696 11 9.96086 11.2107 9.58579 11.5858C9.21071 11.9609 9 12.4696 9 13V17H15V15H11V13H13C13.5304 13 14.0391 12.7893 14.4142 12.4142C14.7893 12.0391 15 11.5304 15 11V9C15 8.46957 14.7893 7.96086 14.4142 7.58579C14.0391 7.21071 13.5304 7 13 7H9ZM12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2Z";

  purchaseBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      purchaseBtns.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const type = btn.dataset.type;

      if (purchaseOptionIconPath) {
        purchaseOptionIconPath.setAttribute(
          "d",
          type === "one-time" ? oneTimeSvgPath : defaultSvgPath,
        );
      }

      if (type === "one-time") {
        oneTimeSection?.classList.remove("hidden");
        oneTimeBtn?.classList.remove("hidden");
        subscriptionSection?.classList.add("hidden");
        subscriptionBtn?.classList.add("hidden");

        upsellWrapper?.forEach((wrapper) => {
          wrapper.classList.remove("hidden");
        });

        subUpsellWrapper?.forEach((wrapper) => {
          wrapper.classList.add("hidden");
        });

        giftWrapper?.forEach((wrapper) => {
          wrapper.classList.add("hidden");
        });
      } else {
        subscriptionSection?.classList.remove("hidden");
        oneTimeSection?.classList.add("hidden");
        subscriptionBtn?.classList.remove("hidden");
        oneTimeBtn?.classList.add("hidden");

        upsellWrapper?.forEach((wrapper) => {
          wrapper.classList.add("hidden");
        });

        giftWrapper?.forEach((wrapper) => {
          wrapper.classList.remove("hidden");
        });

        subUpsellWrapper?.forEach((wrapper) => {
          wrapper.classList.remove("hidden");
        });
      }

      subscriptionPricingHeaders?.forEach((header) => {
        header.classList.toggle("hidden", type === "one-time");
      });
      updateSubscriptionPricingVisibility(type);
      updateSharedSelectorLabels(type);
      syncBundleGroups(getActiveBundleSet(getActiveBundleGroup()));

      selectedSlot = null;

      if (typeof window.updateBundleDisplay === "function") {
        window.updateBundleDisplay(getActiveBundleSet(getActiveBundleGroup()), {
          purchaseType: type,
          sectionEl: getActiveBundleSection(),
        });
      }

      renderSelectedFooter();
      updateBundlePopupTitle();
      updateProceedButtonState();
    });
  });

  document.querySelectorAll(".bundle-selector").forEach((selector) => {
    const buttons = selector.querySelectorAll(".bundle-option");
    const activeButton = selector.querySelector(".bundle-option.active");

    updateSharedSelectorLabels(getActivePurchaseType());

    function activateBundleOption(btn) {
      const targetSet = normalizeBundleSet(btn.dataset.target);
      if (!targetSet) return;

      document
        .querySelectorAll(".bundle-selector .bundle-option")
        .forEach((button) => {
          button.classList.toggle(
            "active",
            normalizeBundleSet(button.dataset.target) === targetSet,
          );
        });

      syncBundleGroups(targetSet);
      updateSharedSelectorLabels(getActivePurchaseType());
      updatePurchaseHeadings(getBundleOptionContent(btn));

      if (typeof window.updateBundleDisplay === "function") {
        window.updateBundleDisplay(targetSet, {
          purchaseType: getActivePurchaseType(),
          sectionEl: getActiveBundleSection(),
        });
      }

      selectedSlot = null;
      renderSelectedFooter();
      updateBundlePopupTitle();
      updateProceedButtonState();

      if (typeof window.bundleButtons_checkSlots === "function") {
        window.bundleButtons_checkSlots();
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        activateBundleOption(btn);
      });
    });

    if (activeButton) {
      activateBundleOption(activeButton);
    }
  });

  document.querySelectorAll(".bundle-tab").forEach((tab) => {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");
      document
        .querySelectorAll(".bundle-tab, .bundle-tab-content")
        .forEach((el) => el.classList.remove("active"));
      this.classList.add("active");
      document
        .querySelector(`[data-content='${target}']`)
        ?.classList.add("active");
    });
  });

  document.addEventListener(
    "click",
    function (e) {
      const favBtn = e.target.closest(".favorite-btn");
      if (!favBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const variantId = favBtn.dataset.variantId || "";
      const productId = favBtn.dataset.productId || "";
      const title = favBtn.dataset.productTitle || "";
      const media = favBtn.dataset.productMedia || "";
      const collectionId = favBtn.dataset.collectionId || "";
      const collectionTitle = favBtn.dataset.collectionTitle || "";

      if (isFavorite(productId)) {
        removeFavorite(productId);
      } else {
        saveFavorite(
          variantId,
          productId,
          title,
          media,
          collectionId,
          collectionTitle,
        );
      }

      updateFavoriteButtonState(favBtn, productId);
    },
    true,
  );

  document.addEventListener("click", async function (e) {
    const target = e.target;
    const footerSlot = target.closest(".bundle-popup__selected-item");
    if (footerSlot && !target.closest(".bundle-popup__selected-remove")) {
      e.preventDefault();
      e.stopPropagation();

      const slotIndex = Number(footerSlot.dataset.slotIndex);
      const activeGroup = getActiveBundleGroup();
      const slot = getBundleSlots(activeGroup)[slotIndex];

      if (slot) {
        selectedSlot = slot;
        updateBundlePopupTitle(selectedSlot);
        openPopup("bundle-collection-popup");
      }

      return;
    }

    if (target.closest(".add-btn")) {
      const addBtn = target.closest(".add-btn");
      e.preventDefault();
      e.stopPropagation();

      selectProductIntoSlot({
        variantId: addBtn.dataset.variantId,
        productId: addBtn.dataset.productId,
        collectionId: addBtn.dataset.collectionId,
        collectionTitle: addBtn.dataset.collectionTitle,
        title: addBtn.dataset.productTitle,
        img: addBtn.dataset.productMedia,
      });

      return;
    }

    if (target.closest(".bundle-collection__image")) {
      const imgContainer = target.closest(".bundle-collection__image");
      e.preventDefault();
      e.stopPropagation();

      if (target.closest(".favorite-btn")) return;

      selectProductIntoSlot({
        variantId: imgContainer.dataset.variantId,
        productId: imgContainer.dataset.productId,
        collectionId: imgContainer.dataset.collectionId,
        collectionTitle: imgContainer.dataset.collectionTitle,
        title: imgContainer.dataset.productTitle,
        img: imgContainer.querySelector("img")?.src || "",
      });

      return;
    }

    if (target.classList.contains("quick-view-btn")) {
      const trigger = target.closest(".quick-view-btn");
      const variantId = trigger.dataset.variantId;
      const productId = trigger.dataset.productId;
      const collectionId = trigger.dataset.collectionId;
      const collectionTitle = trigger.dataset.collectionTitle;
      const title = trigger.dataset.productTitle;
      const media = trigger.dataset.productMedia;

      const quickview = document.getElementById("quickview-popup");
      if (!quickview) return;

      quickview.querySelector(".quickview--title").textContent = title;

      const mediaArray = media.split(",");

      quickview.querySelector(".quickview__media").innerHTML = `
        <div class="swiper quickview-swiper">
          <button class="favorite-btn quickview__fav"
            data-product-id=""
            data-product-title=""
            data-product-media="">
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="swiper-wrapper">
            ${mediaArray
              .map((url) => {
                const cleanUrl = url.trim();
                const srcset = `
                  ${cleanUrl.replace(/width=\d+/, "width=300")} 300w,
                  ${cleanUrl.replace(/width=\d+/, "width=600")} 600w,
                  ${cleanUrl.replace(/width=\d+/, "width=900")} 900w,
                  ${cleanUrl.replace(/width=\d+/, "width=1200")} 1200w
                `.trim();

                return `
                  <div class="swiper-slide">
                    <img 
                      src="${cleanUrl}"
                      srcset="${srcset}"
                      sizes="(max-width: 768px) 100vw, 600px"
                      alt="${title}"
                      loading="lazy"
                    >
                  </div>
                `;
              })
              .join("")}
          </div>

          <div class="quickview-navigation">
            <div class="quickview-prev">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <circle cx="17.0356" cy="17.0352" r="16.4674" transform="rotate(180 17.0356 17.0352)" fill="white" stroke="black" stroke-width="1.13568"/>
                <path d="M13.0239 16.431C12.6912 16.7636 12.6912 17.3029 13.0239 17.6356L18.4444 23.0561C18.7771 23.3888 19.3164 23.3888 19.649 23.0561C19.9816 22.7235 19.9816 22.1842 19.649 21.8516L14.8307 17.0333L19.649 12.215C19.9816 11.8824 19.9816 11.3431 19.649 11.0104C19.3164 10.6778 18.7771 10.6778 18.4444 11.0104L13.0239 16.431ZM13.6263 17.0333L13.6263 16.1815L13.6262 16.1815L13.6262 17.0333L13.6262 17.8851L13.6263 17.8851L13.6263 17.0333Z" fill="black"/>
              </svg>
            </div>
            <div class="quickview-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <circle cx="17.0356" cy="17.0352" r="16.4674" fill="white" stroke="black" stroke-width="1.13568"/>
                <path d="M21.0473 17.6394C21.38 17.3068 21.38 16.7675 21.0473 16.4348L15.6268 11.0143C15.2941 10.6816 14.7548 10.6816 14.4222 11.0143C14.0896 11.3469 14.0896 11.8862 14.4222 12.2188L19.2405 17.0371L14.4222 21.8554C14.0896 22.188 14.0896 22.7273 14.4222 23.06C14.7548 23.3926 15.2941 23.3926 15.6268 23.06L21.0473 17.6394ZM20.445 17.0371L20.445 17.8889L20.4451 17.8889L20.4451 17.0371L20.4451 16.1853L20.445 16.1853L20.445 17.0371Z" fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="quick-view-pagination swiper-pagination"></div>
      `;

      if (window.quickviewSwiper) {
        window.quickviewSwiper.destroy(true, true);
      }

      window.quickviewSwiper = new Swiper(".quickview-swiper", {
        speed: 600,
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: ".bundle-popup__content .quickview-next",
          prevEl: ".bundle-popup__content .quickview-prev",
        },
        pagination: {
          el: ".bundle-popup__content .swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
      });

      const favBtn = quickview.querySelector(".quickview__fav");
      const selectBtn = quickview.querySelector(".quickview__select");

      favBtn.dataset.productId = productId;
      favBtn.dataset.productTitle = title;
      favBtn.dataset.productMedia = media;
      favBtn.dataset.variantId = variantId;
      favBtn.dataset.collectionId = collectionId;
      favBtn.dataset.collectionTitle = collectionTitle;

      selectBtn.dataset.variantId = variantId;
      selectBtn.dataset.productTitle = title;
      selectBtn.dataset.collectionId = collectionId;
      selectBtn.dataset.collectionTitle = collectionTitle;
      selectBtn.dataset.productMedia = mediaArray[0]?.trim() || media;
      selectBtn.dataset.productId = productId;

      updateFavoriteButtonState(favBtn, productId);
      openPopup("quickview-popup");
      return;
    }

    if (target.classList.contains("remove-favorite")) {
      const id = target.dataset.removeId;
      removeFavorite(id);
      return;
    }

    if (target.classList.contains("quickview__select")) {
      selectProductIntoSlot({
        variantId: target.dataset.variantId,
        productId: target.dataset.productId,
        collectionId: target.dataset.collectionId,
        collectionTitle: target.dataset.collectionTitle,
        title: target.dataset.productTitle,
        img: target.dataset.productMedia,
      });

      closePopup("quickview-popup");
      return;
    }

    const selectedRemoveBtn = target.closest(".bundle-popup__selected-remove");
    if (selectedRemoveBtn) {
      e.preventDefault();
      e.stopPropagation();

      const slotIndex = Number(selectedRemoveBtn.dataset.slotIndex);
      const activeGroup = getActiveBundleGroup();
      const slot = getBundleSlots(activeGroup)[slotIndex];

      clearSlot(slot);
      return;
    }

    const removeSlotBtn = target.closest(".remove-btn");
    if (removeSlotBtn) {
      const slot = removeSlotBtn.closest(".bundle-product");
      clearSlot(slot);
      return;
    }

    const proceedBtn = target.closest?.("#bundle-popup-proceed");
    if (proceedBtn) {
      e.preventDefault();

      const btn = proceedBtn;
      if (btn.disabled || btn.classList.contains("is-loading")) return;
      if (!isBundleComplete()) return;

      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.setAttribute("aria-busy", "true");

      // Hide cart drawer immediately for a faster-feeling checkout handoff.
      hideUpCartTemporarily();

      let isRedirecting = false;

      try {
        const success = await buildRechargeBundleFromPopup({
          redirectToCheckout: true,
          onBeforeRedirect: () => {
            isRedirecting = true;
          },
        });

        if (!success && !isRedirecting) {
          btn.classList.remove("is-loading");
          btn.removeAttribute("aria-busy");
          btn.disabled = false;
          updateProceedButtonState();
          restoreUpCartIfNeeded();
        }
      } catch (error) {
        console.error("Proceed to checkout failed:", error);

        if (!isRedirecting) {
          alert("Something went wrong. Please try again.");
          btn.classList.remove("is-loading");
          btn.removeAttribute("aria-busy");
          btn.disabled = false;
          updateProceedButtonState();
          restoreUpCartIfNeeded();
        }
      }

      return;
    }

    if (target.closest(".bundle-product") && !target.closest(".remove-btn")) {
      selectedSlot = target.closest(".bundle-product");
      renderSelectedFooter();
      updateBundlePopupTitle(selectedSlot);
      openPopup("bundle-collection-popup");
      return;
    }

    if (
      target.classList.contains("bundle-popup-overlay") ||
      target.closest(".bundle-popup__close")
    ) {
      const popupToClose =
        target.closest(".bundle-popup-overlay") ||
        document.getElementById(
          target.closest(".bundle-popup__close")?.dataset.popupClose,
        );

      if (popupToClose) {
        popupToClose.classList.remove("active");
        document.body.style.overflow = "";

        if (popupToClose.id === "bundle-collection-popup") {
          selectedSlot = null;
          updateBundlePopupTitle();
        }
      }
    }
  });
  window.bundlePopup_openSlot = function (slot = null) {
    const activeGroup = getActiveBundleGroup();
    if (!activeGroup) return;

    const slots = getBundleSlots(activeGroup);

    const nextIncompleteSlot = slots.find((bundleSlot) => {
      const variantId = bundleSlot.dataset.id || "";
      const productId = bundleSlot.dataset.product || "";

      return variantId.trim() === "" || productId.trim() === "";
    });

    if (slot && slot.closest(".bundle-group") === activeGroup) {
      selectedSlot = slot;
    } else {
      selectedSlot = nextIncompleteSlot || slots[0] || null;
    }

    renderSelectedFooter();
    updateBundlePopupTitle(selectedSlot);
    openPopup("bundle-collection-popup");
  };

  window.bundlePopup_openNextEmptySlot = function () {
    window.bundlePopup_openSlot();
  };

  window.bundlePopup_isComplete = function () {
    return isBundleComplete();
  };

  loadFavorites();
  setTimeout(updateHeartStates, 100);
  renderSelectedFooter();

  updateBundlePopupTitle();
  updateProceedButtonState();
  window.addEventListener("pageshow", function () {
    restoreUpCartIfNeeded();
  });
});
// FILTER TRIGGER

document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".filter-trigger");
  const filters = document.querySelector(".bundle-popup__filters");

  if (!trigger || !filters) return;

  const openFilters = () => {
    filters.classList.add("active");
    trigger.classList.add("active");
    trigger;
    filters.style.maxHeight = filters.scrollHeight + "px";
  };

  const closeFilters = () => {
    filters.style.maxHeight = filters.scrollHeight + "px";
    requestAnimationFrame(() => {
      filters.classList.remove("active");
      trigger.classList.remove("active");
      filters.style.maxHeight = "0px";
    });
  };

  const toggleFilters = () => {
    if (filters.classList.contains("active")) {
      closeFilters();
    } else {
      openFilters();
    }
  };

  trigger.addEventListener("click", toggleFilters);

  window.addEventListener("resize", () => {
    if (filters.classList.contains("active")) {
      filters.style.maxHeight = filters.scrollHeight + "px";
    }
  });

  filters.addEventListener("transitionend", (e) => {
    if (e.propertyName !== "max-height") return;

    if (filters.classList.contains("active")) {
      filters.style.maxHeight = "none";
    }
  });
});
// SEARCH FUNCTIONALITY

document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector("#bundle-collection-popup");
  if (!popup) return;

  const trigger = popup.querySelector(".search-trigger");
  const searchWrap = popup.querySelector("[data-bundle-search]");
  const input = popup.querySelector("[data-bundle-search-input]");
  const clearBtn = popup.querySelector("[data-bundle-search-clear]");

  if (!trigger || !searchWrap || !input || !clearBtn) return;

  const normalize = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const parseList = (value) => {
    if (!value) return [];
    return String(value)
      .split("||")
      .map((item) => normalize(item))
      .filter(Boolean);
  };

  const getActiveContent = () => {
    return popup.querySelector(".bundle-tab-content.active");
  };

  const itemMatchesQuery = (item, query) => {
    if (!query) return true;

    const searchableText = [
      item.dataset.productTitle,
      item.dataset.productVendor,
      item.dataset.productType,
      ...parseList(item.dataset.productTags),
      ...parseList(item.dataset.productOptions),
      item.textContent,
    ]
      .map((value) => normalize(value))
      .join(" ");

    return searchableText.includes(query);
  };

  const getSearchEmptyNode = (activeContent) => {
    let emptyNode = activeContent.querySelector("[data-search-empty]");

    if (!emptyNode) {
      emptyNode = document.createElement("p");
      emptyNode.className =
        "bundle-collection__empty bundle-collection__search-empty";
      emptyNode.dataset.searchEmpty = "";
      emptyNode.hidden = true;
      emptyNode.textContent = "No products match your search.";

      const grid = activeContent.querySelector(".bundle-collection__grid");
      if (grid) {
        grid.insertAdjacentElement("afterend", emptyNode);
      } else {
        activeContent.appendChild(emptyNode);
      }
    }

    return emptyNode;
  };

  const applySearch = () => {
    const activeContent = getActiveContent();
    if (!activeContent) return;

    const items = activeContent.querySelectorAll(".bundle-collection__item");
    const query = normalize(input.value);

    items.forEach((item) => {
      const match = itemMatchesQuery(item, query);
      item.classList.toggle("is-hidden-by-search", !match);
    });

    clearBtn.hidden = !query;

    const emptyNode = getSearchEmptyNode(activeContent);

    const hasVisibleItem = Array.from(items).some((item) => {
      return (
        !item.classList.contains("is-hidden-by-search") &&
        !item.classList.contains("is-hidden-by-filter")
      );
    });

    emptyNode.hidden = !query || hasVisibleItem;
  };

  const openSearch = () => {
    searchWrap.classList.add("active");
    searchWrap.style.maxHeight = "0px";

    requestAnimationFrame(() => {
      searchWrap.style.maxHeight = searchWrap.scrollHeight + "px";
    });

    requestAnimationFrame(() => {
      input.focus();
    });
  };

  const closeSearch = () => {
    searchWrap.style.maxHeight = searchWrap.scrollHeight + "px";

    requestAnimationFrame(() => {
      searchWrap.classList.remove("active");
      searchWrap.style.maxHeight = "0px";
    });
  };

  const toggleSearch = () => {
    if (searchWrap.classList.contains("active")) {
      closeSearch();
    } else {
      openSearch();
    }
  };

  trigger.addEventListener("click", toggleSearch);

  input.addEventListener("input", applySearch);

  clearBtn.addEventListener("click", () => {
    input.value = "";
    applySearch();
    input.focus();
  });

  popup.addEventListener("click", (event) => {
    if (event.target.closest(".bundle-tab")) {
      requestAnimationFrame(applySearch);
    }
  });

  popup.addEventListener("change", (event) => {
    if (event.target.closest(".bundle-filter-checkbox")) {
      requestAnimationFrame(applySearch);
    }
  });

  document.addEventListener("bundle:products-updated", () => {
    requestAnimationFrame(applySearch);
  });

  window.addEventListener("resize", () => {
    if (searchWrap.classList.contains("active")) {
      searchWrap.style.maxHeight = searchWrap.scrollHeight + "px";
    }
  });

  searchWrap.addEventListener("transitionend", (event) => {
    if (event.propertyName !== "max-height") return;

    if (searchWrap.classList.contains("active")) {
      searchWrap.style.maxHeight = "none";
    }
  });
});
